// extracted by mini-css-extract-plugin
export default {"addToCartControl":"UZ-z","giftCard":"VZ-z","btnContainer":"WZ-z","cartButton":"XZ-z","disabled":"YZ-z"};